export default "__VITE_ASSET__CWmrxr_L__"